import { TournamentState } from '@ps/web-poker-tile-mappers';

import { mttDefaultState } from '@swf/poker';

import type { PokerPowerPathState } from './types';

export const defaultActiveFilters = {
  state: [
    TournamentState.LATE_REGISTRATION,
    TournamentState.REGISTERING,
    TournamentState.RUNNING,
    TournamentState.PHASE
  ]
};

export const defaultState: PokerPowerPathState = {
  ...mttDefaultState,
  isLoading: false,
  hasDataError: false,
  steps: {
    step1: null,
    step2SNG: null,
    step2Scheduled: null,
    step3: null,
    step4: null
  },
  passesData: { gold: [], silver: [], bronze: [] },
  passesError: '',
  hasPreloaded: false,
  activeFilters: {
    ...defaultActiveFilters
  }
};
